<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <div>
        <div class="search-wrap">
          <el-button size="mini" @click="search">查询</el-button>
          <el-button size="mini" @click="ERP.navigateTo('/meter/meterNoteExcel')" style="margin-right: 5px;" v-if="ERP.isPermission(4007002002)">抄表</el-button>
        </div>

        <div style="margin-bottom: 10px;">
          <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
            <el-descriptions-item label="仪表编号">
              <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="当前房产">
              <el-input size="mini" placeholder="请选择房产" v-model="where.house_name" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="抄表类型">
              <el-radio disabled size="mini" v-for="item in [{name:'正常抄表',val:1},{name:'中途抄表',val:2}]"
                        :key="item.val" v-model="where.note_type" :label="item.val">{{ item.name }}</el-radio>
            </el-descriptions-item>
            <el-descriptions-item label="线路">
              <el-input size="mini" placeholder="请输入线路" v-model="where.line" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="仪表状态">
              <el-checkbox-group v-model="where.status_ids">
                <el-checkbox v-for="item in [{name:'在用',val:1},{name:'停用',val:0}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
            <el-descriptions-item label="仪表名称">
              <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="仪表类型">
              <el-select size="mini" style="width: 100%" v-model="where.meter_type" filterable placeholder="类型" class="kuan">
                <el-option
                  v-for="item in meter_type_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="仪表性质">
              <el-checkbox-group v-model="where.meter_nature_ids">
                <el-checkbox v-for="item in meter_nature_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
            <el-descriptions-item label="审核标志">
              <el-checkbox-group v-model="where.is_examine_ids">
                <el-checkbox v-for="item in [{name:'未审核',val:0},{name:'已审核',val:1}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
            <el-descriptions-item label="抄表日期">
              <el-date-picker
                style="width: 250px;"
                size="mini"
                v-model="where.start_end_time"
                unlink-panels
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div>
          <el-table v-if="pageData" v-loading="loading" border width="100%" height="550" :data="pageData.list" @selection-change="handleSelectionChange">
            <el-table-column prop="id" label="id"  width="50"></el-table-column>
            <el-table-column prop="house_name" label="所在房产" width="200"></el-table-column>
            <el-table-column prop="number" label="仪表编号 " width="100">
              <template slot-scope="scope">
                <el-link type="primary" @click="edit(scope.row)">{{scope.row.number}}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="仪表名称 " width="100"></el-table-column>
            <el-table-column prop="line" label="线路 " width="100"></el-table-column>
            <el-table-column prop="meter_type_name" label="仪表类型"  width="100"></el-table-column>
            <el-table-column prop="charging_standard_name" label="收费标准 " width="250"></el-table-column>
            <el-table-column prop="charging_standard_money" label="单价 " width="100"></el-table-column>
            <el-table-column prop="read_number" label="本期读数" width="100">
            </el-table-column>
            <el-table-column prop="dosage_number" label="本期用量" width="100"></el-table-column>
            <el-table-column prop="read_time" label="抄表日期" width="100"></el-table-column>
            <el-table-column prop="mn_remarks" label="备注" width="100"></el-table-column>
            <el-table-column prop="last_year_dosage_number" label="去年同期用量" width="100"></el-table-column>
            <el-table-column prop="last_dosage_number" label="上期用量" width="100"></el-table-column>
            <el-table-column prop="mn_admin_name" label="抄表人" width="100"></el-table-column>
            <el-table-column prop="is_examine" label="审核" width="100">
              <template slot-scope="scope">
                {{scope.row.is_examine?'已审':'未审'}}
              </template>
            </el-table-column>
            <el-table-column prop="mn_files" label="图片" width="100"></el-table-column>
            <!-- <el-table-column label="操作 " width="180">
              <template slot-scope="scope">
                <el-button type="primary" size="mini">能耗分析
                </el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </div>

        <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
          <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
        </div>
      </div>
    </div>

    <!-- 修改窗口 -->
    <el-dialog title="编辑" z-index="990" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px">
      <div style="max-height: 700px;overflow-y: auto;">
        <el-descriptions class="margin-top" title="" :column="2" size="mini" border>
          <el-descriptions-item label="仪表编号">
            <el-input size="mini" readonly class="form-input" v-model="form.number" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="所在房产">
            <el-input size="mini" readonly class="form-input" v-model="form.house_name" clearable
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表名称">
            <el-input size="mini" readonly class="form-input" v-model="form.name" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="倍率">
            <el-input size="mini" readonly class="form-input" v-model="form.magnification" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表户号">
            <el-input size="mini" readonly class="form-input" v-model="form.house_number" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="初始读数">
            <el-input size="mini" readonly class="form-input" v-model="form.start_number" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表表号">
            <el-input size="mini" readonly class="form-input" v-model="form.meter_number" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="回程">
            <el-input size="mini" readonly class="form-input" v-model="form.return_trip" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表类型">
            <!--                        <el-input size="mini" class="form-input" v-model="form.meter_type" autocomplete="off"></el-input>-->
            <el-select size="mini" disabled style="width: 100%" v-model="form.meter_type" filterable placeholder="仪表类型" class="kuan">
              <el-option
                v-for="item in meter_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="安装日期">
            <!--            <el-input size="mini" class="form-input" v-model="form.install_time" autocomplete="off"></el-input>-->
            <el-date-picker disabled
              v-model="form.install_time"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="收费标准">
            <!--            <el-input size="mini" class="form-input" v-model="form.charging_standard" autocomplete="off"></el-input>-->
            <el-select size="mini" disabled style="width: 100%" v-model="form.charging_standard" filterable placeholder="收费标准" class="kuan">
              <el-option readonly
                v-for="item in house_charge_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="上次抄表时间">
            <!--            <el-input size="mini" class="form-input" v-model="form.reading_time" placeholder="仪表初始化时上次抄表时间" autocomplete="off"></el-input>-->
            <el-date-picker disabled
              v-model="form.reading_time"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="仪表排序">
            <el-input size="mini" readonly class="form-input" v-model="form.sort" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="位置">
            <el-input size="mini" readonly class="form-input" v-model="form.position" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表状态">
            <el-radio disabled v-for="item in [{name:'在用',val:1},{name:'停用',val:0}]"
                      :key="item.val" v-model="form.status" :label="item.val">{{ item.name }}</el-radio>
          </el-descriptions-item>
          <el-descriptions-item label="规格">
            <el-input size="mini" readonly class="form-input" v-model="form.specifications" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表性质">
            <el-radio disabled v-for="item in meter_nature_list"
                      :key="item.val" v-model="form.meter_nature" :label="item.val">{{ item.name }}</el-radio>
          </el-descriptions-item>
          <el-descriptions-item label="线路">
            <el-input readonly size="mini" class="form-input" v-model="form.line" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="备注">
            <el-input readonly
              type="textarea"
              placeholder="请输入内容"
              v-model="form.remarks"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="附件">
            <UploadFilesSysc disabled :host-url="host_url" :upload-url="host_url+'/admin/MeterNote/uploadFile'" :limit="20"
                             v-model="form.files"/>
          </el-descriptions-item>
          <el-descriptions-item label="二维码">
            <!--                        <el-input class="form-input" v-model="form.name" autocomplete="off"></el-input>-->
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>

import ErpTree from "../Common/erp-tree";
import UploadFilesSysc from "../Contract/components/UploadFilesSysc";
import ErpTreeStatus from "../Common/erp-tree-status";

export default {
  name: "MeterNoteDetail",
  components: {ErpTreeStatus, UploadFilesSysc, ErpTree},
  data() {
    return {
      host_url: "",
      keyword: '',
      loading: false,
      where: {
        routeType:1,
        meter_type: "",
        house_name: "",
        number: "",
        charging_standard: "",
        status: "",
        status_ids: [1,0],
        line: "",
        meter_nature: "",
        meter_nature_ids: [1,2,3,4],
        name: "",
        note_type:"",
        is_accident:"",
        is_examine:"",
        is_examine_ids:[1,0],
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      dialogVisible: false,
      treeDialogVisible: false,
      form: {
        pid:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: "",
        magnification: "",
        start_number: "",
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
      },
      update_form: {
        pid:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: "",
        magnification: "",
        start_number: "",
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
        end_number:"",
        meter_update_time:"",
        end_use:"",
        admin_name:"",
        admin_id:"",
      },
      uploadUrl: "",
      month_value: "",
      business_list: [],
      entry_type_name: "",
      multipleSelection: [],
      meter_type_list: [],
      house_charge_list:[],
      chargeItem_name_id:"",
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      charging_standard:"",
      mapDialogTableVisible:false,
      updateDialogVisible:false,
      yDialogVisible:false,
      mapCenter:[0,0],
    }
  },
  created() {
    this.host_url = __HTTP__.defaults.baseURL;
    // this.month_value=CommonHelp.date("YYYY-MM");
    this.getMeterTypeList()
  },
  watch: {
    dialogVisible(val) {
      if (val == false) {
        // this.fileList = []
      }
    },
    "form.project_id":function (n) {
      this.getHouseChargeList();
    },
    "form.meter_type":function (n) {
      this.chargeItem_name_id=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_id||"";
      this.getHouseChargeList();
    },
    "where.meter_type":function (n) {
      this.chargeItem_name_id=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_id||"";
      this.getHouseChargeList();
    }
  },
  computed: {
    multipleSelection_meter_ids(){
      return this.multipleSelection.map(ret=>{
        return ret.mn_id
      });
    },
    multipleSelection_meter_examine_type_num(){
      let set=new Set();
      this.multipleSelection.map(ret=>{
        set.add(ret.is_examine)
      });
      return Array.from(set).length;
    },
    multipleSelection_meter_examine(){
      return this.multipleSelection.filter(ret=>{
        return !!ret.is_examine
      });
    },
    multipleSelection_meter_not_examine(){
      return this.multipleSelection.filter(ret=>{
        return !ret.is_examine
      });
    },
  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id: '',
        pid:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: "",
        magnification: "",
        start_number: "",
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that = this;
      that.loading = true;
      let where = reObject(this.where);
      ERP.getRequest({
        url: "admin/MeterNote/getList",
        data: {
          where: JSON.stringify(where),
          page: this.pageData.page,
          page_size: this.pageData.pageSize
        }
      }, res => {
        if (res.code) {
          res.data.list.map(ret => {

            // ret.is_invoice=ret.is_invoice === 1;
            // ret.is_paid=ret.is_paid === 1;
            return ret;
          })
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    edit(item) {
      if (!item) {
        let project_id= this.form.project_id
        let house_id= this.form.house_id
        let house_name= this.form.house_name
        this.form = this.getFormData({project_id:project_id,house_id:house_id,house_name:house_name})
      } else {
        this.form = reObject(item);
      }
      this.dialogVisible = true
    },

    meterShifting(item) {
      this.$refs.MeterShifting.show(reObject(item))
    },

    updateEdit(item) {
      if (!item) {
        this.$message.error('无数据')
        return false;
      } else {
        this.update_form = reObject(item);
        this.form = reObject(item);
      }
      this.updateDialogVisible = true
    },

    submitForm() {
      var that = this;
      that.formLoading = true
      let data = Object.assign({}, this.form)

      ERP.postRequest({url: "admin/MeterNote/save", data: data}, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.dialogVisible = false
          that.getList()
        }
        that.formLoading = false
      })
    },

    updateSubmitForm() {
      var that = this;
      that.formLoading = true
      //原仪表
      let update_form = Object.assign({}, this.update_form)
      ERP.postRequest({url: "admin/MeterNote/save", data: update_form}, res => {
        if (res.code) {
          //新仪表
          let form = Object.assign({}, this.form)
          form.pid=form.id;
          form.id=undefined;
          form.meter_update_time="";
          form.end_use="";
          form.end_number="";

          ERP.postRequest({url: "admin/MeterNote/save", data: form}, res => {
            that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
            if (res.code) {
              that.updateDialogVisible = false
              that.getList()
            }
            that.formLoading = false
          })
        }
      })
    },

    setFrom(data){
      var that = this;
      ERP.postRequest({url: "admin/MeterNote/save", data: data}, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      })
    },
    del(item) {
      var that = this;
      ERP.postRequest({
        url: "admin/MeterNote/delete",
        data: {
          id: item.id
        }
      }, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      })
    },
    dels() {
      var that = this;
      ERP.postRequest({
        url: "admin/MeterNote/delete",
        data: {
          ids: this.multipleSelection_meter_ids.join(',')
        }
      }, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      })
    },
    allDel() {
      var that = this;
      if(!that.where.house_name){
        that.$message.error('请选择项目或房产')
        return false;
      }
      ERP.postRequest({
        url: "admin/MeterNote/allDel",
        data: {
          where: JSON.stringify(that.where)
        }
      }, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      })
    },
    examine(is_examine=0){
      var that=this;
      that.setFrom({
        ids:this.multipleSelection_meter_ids.join(','),
        is_examine:is_examine,
      })
    },
    allExamine(is_examine=0){
      var that=this;
      if(!that.where.house_name){
        that.$message.error('请选择项目或房产')
        return false;
      }
      ERP.postRequest({
        url: "admin/MeterNote/allUpdate",
        data: {
          where: JSON.stringify(that.where),
          data:JSON.stringify({is_examine:is_examine})
        }
      }, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      })
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    shoeTreeDialogVisible() {
      this.treeDialogVisible = true;
    },
    nodeClick2(data) {
      let tree_str = data.tree.map(ret => {
        return ret.name
      }).join('->');
      console.log(data);
      this.form.project_id = data.tree[0].pindex_id;
      this.form.house_name = tree_str;
      this.form.house_id = data.tree[data.tree.length - 1].house_id;
    },
    nodeClick(data) {
      let tree_str = data.tree.map(ret => {
        return ret.name
      }).join('->');
      //console.log(data);
      this.form.project_id = data.tree[0].pindex_id;
      this.form.house_name = tree_str;
      this.form.house_id = data.tree[data.tree.length - 1].house_id;
      this.where.house_name=tree_str;
      this.getList();
    },
    getMeterTypeList(){
      var that=this;
      let where={};
      ERP.getRequest({
        url:"admin/MeterType/getList",
        data:{
          where:JSON.stringify(where),
          field:"id,name,expenditure_id,expenditure_name",
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){
      var that=this;
      let where={};
      this.form.project_id&&(where.pindex_id=this.form.project_id);
      this.chargeItem_name_id&&(where.chargeItem_name_id=this.chargeItem_name_id);
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
    showMapDialogTableVisible(){
      this.mapDialogTableVisible=true
    },
    AmapManager(e){
      console.log(e)
    },
    amapManagerClick(e){
      console.log(e)
    },
    navToMeterExcel(){
      ERP.navigateTo("/meter/meterExcel");
    },
    stopUse(){
      var that=this;
      that.$confirm('您确定停用该仪表吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.setFrom({
          ids:that.multipleSelection.map(ret=>{ return ret.id }),
          status:0
        });
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消'
        });
      });
    },
    updateChargingStandard(){
      var that=this;
      that.$confirm('您确定修改该仪表收费标准吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.setFrom({
          ids:that.multipleSelection.map(ret=>{ return ret.id }),
          charging_standard:that.charging_standard,
        });
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消'
        });
      });

    },
  }
}

function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>
<style lang="scss" scoped>

.el-button--primary, .el-button--danger, .el-button--success, .el-button--warning {
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td, th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  overflow-x:hidden;
}

.form-input {
  width: 100%;
}

.table-wrap {
  width: calc(100vw - 450px);
  overflow-x: scroll;
}
.amap-box{
  width: 500px;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/ManagerMeter/MeterNoteDetail.vue